import { useState, useEffect } from "react";

export default function useFiltros(fetch, modelo, pesq, setDadosPesq, filtroId, tipo) {
    const [loading, setLoading] = useState(false);
    const modeloTratado = modelo + (filtroId ? filtroId : '') + (tipo ? tipo : '');

    useEffect(() => {
        if (!pesq[modeloTratado]) {
            setLoading(true);
            fetch()
                .post(`/${modelo}/getlist`, { id: filtroId, tipo })
                .then((response) => {
                    setLoading(false);
                    setDadosPesq(modeloTratado, response.data);
                })
                .catch(() => setLoading(false));
        }
    }, [modeloTratado]);

    return [loading, modeloTratado];
}